import Tracker from "../prop-trackers/tracker.js";
import DictTracker from "../prop-trackers/dict-tracker.js";
import { ForEach, ValueTracker } from "./for-each.js";

class Mapper extends Tracker {
    constructor(rootTracker, createValueMapper, userdata) {
        super();

        this._createValueMapper = createValueMapper;

        this._mapperKey = new WeakMap();
        this._forEachTracker = new ForEach(rootTracker, (key) => {
            const mapper = createValueMapper(key);
            this._mapperKey.set(mapper, key);
            return mapper;
        });

        this._outputTracker = new DictTracker(userdata);

        const needsUpdate = this.protected_needsUpdate.bind(this);
        this._forEachTracker.listenNeedsUpdate(needsUpdate);
    }

    protected_startUpdate() {
        this._forEachTracker.update(({ trackers }) => {
            for (const mapper of trackers) {
                const key = this._mapperKey.get(mapper);

                mapper.update(({ prop: { newExists, newValue } }) => {
                    if (newExists) {
                        this._outputTracker.setValue(key, newValue);
                    } else {
                        this._outputTracker.deleteValue(key);
                    }
                });
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

Mapper.ValueMapper = ValueTracker;

export default Mapper;
export { Mapper, ValueTracker as ValueMapper };
